import { hotList, feedCats } from "@/mocks/chigua";

const maxHeat = hotList[0].heat;

export default function HotRank() {
  return (
    <section id="hot" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-sm font-semibold tracking-widest text-primary-500 uppercase">实时热榜</p>
            <h2 className="mt-2 font-fun text-3xl text-foreground-950 md:text-4xl">此刻全网的瓜，都在这里</h2>
            <p className="mt-2 max-w-xl text-foreground-600">
              按全网讨论热度实时排序，热门事件一手掌握。点按热度条可大致感受每条瓜的"火爆程度"。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-semibold text-primary-700">
            <i className="ri-time-line" aria-hidden="true"></i>每 5 分钟自动刷新
          </span>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-[1fr_360px]">
          <ol className="divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
            {hotList.map((h, i) => {
              const top3 = i < 3;
              return (
                <li key={h.title} className="flex items-center gap-4 px-5 py-4 transition-colors hover:bg-background-100/60">
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg font-fun text-lg ${
                      top3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-500"
                    }`}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate font-medium text-foreground-900 md:text-base">{h.title}</p>
                    <div className="mt-2 flex items-center gap-3">
                      <div className="h-1.5 w-full max-w-[260px] overflow-hidden rounded-full bg-background-200">
                        <div
                          className={`h-full rounded-full ${top3 ? "bg-primary-500" : "bg-accent-400"}`}
                          style={{ width: `${(h.heat / maxHeat) * 100}%` }}
                        ></div>
                      </div>
                      <span className="whitespace-nowrap text-xs text-foreground-500">
                        <i className="ri-fire-fill mr-0.5 text-primary-500" aria-hidden="true"></i>
                        {h.heat}万热度
                      </span>
                    </div>
                  </div>
                  <span className="hidden rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-semibold text-secondary-800 sm:inline-flex">
                    {h.tag}
                  </span>
                </li>
              );
            })}
          </ol>

          <aside className="space-y-6">
            <div className="rounded-2xl border border-background-200 bg-primary-600 p-6 text-background-50">
              <h3 className="font-fun text-xl">等一个新瓜？</h3>
              <p className="mt-2 text-sm text-background-50/85">
                别天天蹲热搜了，把"吃瓜雷达"交给看吃瓜。新瓜爆出第一时间推送给你。
              </p>
              <a
                href="#subscribe"
                className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-400 px-5 py-2.5 text-sm font-bold text-primary-950 transition-colors hover:bg-accent-300"
              >
                <i className="ri-notification-3-line" aria-hidden="true"></i>开启新瓜提醒
              </a>
            </div>

            <div className="rounded-2xl border border-background-200 bg-background-50 p-6">
              <h3 className="font-fun text-lg text-foreground-900">按频道快速进入</h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {feedCats
                  .filter((c) => c.key !== "all")
                  .map((c) => (
                    <a
                      key={c.key}
                      href="#live"
                      className="rounded-full bg-secondary-100 px-3.5 py-1.5 text-sm font-semibold text-secondary-800 transition-colors hover:bg-secondary-500 hover:text-background-50"
                    >
                      {c.label}
                    </a>
                  ))}
              </div>
              <div className="mt-6 space-y-3 text-sm">
                <p className="flex items-center gap-2 text-foreground-600">
                  <span className="h-2.5 w-2.5 rounded-full bg-primary-500"></span>
                  深色高亮 = 本周热度 TOP 3
                </p>
                <p className="flex items-center gap-2 text-foreground-600">
                  <span className="h-2.5 w-2.5 rounded-full bg-accent-400"></span>
                  浅色 = 持续升温中
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}